import {CreateGuestPayload} from '../../services';
import {PAYLOAD_FIELDS_NAMES} from '../guestForm';

function getHasSomeCustomFields(formData: CreateGuestPayload) {
  const formNames = Object.values(PAYLOAD_FIELDS_NAMES);
  const formDataNames = Object.keys(formData);

  return formDataNames
    .filter(name => {
      return !formNames.includes(name as PAYLOAD_FIELDS_NAMES);
    })
    .some(name => {
      return Boolean(formData[name as PAYLOAD_FIELDS_NAMES]);
    });
}

export {getHasSomeCustomFields};
